import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import LendersView from "./pages/lenders-view";
import LenderOnboarding from "./pages/lender-onboarding";
import LenderActions from "./pages/lender-actions";
import LenderAnalysis from "./pages/lender-analysis";


export default function Lenders() {
    return (
        <Switch>
            <Route exact path={"/app/lenders/"} component={LenderActions}/>
            <Route exact path={"/app/lenders/analysis"} component={LenderAnalysis}/>
            <Route exact path={"/app/lenders/credit-policy"} component={LendersView}/>
            <Route exact path={"/app/lenders/list"} component={LendersView}/>
            <Route exact path={"/app/lenders/view/:lenderId"} component={LendersView}/>
            <Route exact path={"/app/lenders/onboarding/:lenderId?"} component={LenderOnboarding}/>
            <Redirect to={"/app/lenders/"} />
        </Switch>
    );
}


